import dynamic from "next/dynamic";

export const Back = dynamic(() => import("./component"));
